import fetch from 'isomorphic-fetch'
import whitelist from '/api/whitelist'
import { Toast } from 'antd-mobile'
import { hashHistory } from 'react-router'
import { handleLocation, getUserCode } from '/api/tools'
// 企业微信转发 -- 登陆页
const auth_url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww4643f3b8e6508f1d&redirect_uri=https%3a%2f%2fcwqw.grinm.com%2f&response_type=code&scope=snsapi_base#wechat_redirect'
//是否正在认证
let isAuthing = false;

const handleRequest = (url, method, body = {}, json = false) => {
	let has = false
	whitelist.forEach(val => {
		if (val == url) has = true
	})

	let token = localStorage.getItem('token') || ''

	let header = Object.assign({}, {
		'Content-Type': json ? 'application/json' : 'application/x-www-form-urlencoded'
	}, has ? {} : {
		'Authorization': `Bearer ${token}`
	})

	if (method == 'UPLOAD') {
		method = 'POST'
		delete header['Content-Type']
	}

	let req = {
		method,
		headers: new Headers(header)
	}
	if (method == 'POST') {
		req = Object.assign({
			body: json ? JSON.stringify(body) : body,
			bodyUsed: true
		}, req)
	}

	// let wholeUrl = `${process.env.API_URL}${url}	`
	let wholeUrl = url

	if (process.env.NODE_ENV == 'production' && url.substr(0,7)!='/weixin') {
		wholeUrl = `/xpro${url}`
	}

	return new Request(wholeUrl, req)
}

const handleResponse = res => new Promise((rsl, rej) => {
		rsl(res.json())
}).then(res => {
	if (res.code === 700) {
		// 用户认证
		var params = handleLocation()
		if(params.code && !isAuthing){
			isAuthing = true
			fetchAuth({code: params.code})
		}else if(window.platform === 'feishu' && !isAuthing){
			isAuthing = true
			getUserCode().then(code => {
				fetchAuth({code, platform: 'feishu'})
			})
		}else if(!isAuthing){
			//进行绑定 -- 登陆页
			window.location.href = auth_url
		}
	} else if (res.code !== 200) {
		Toast.fail(res.message)
	}
	return res
})
.catch(err => {
	// Toast.offline('请求超时')
	console.error(new Error(`status: ${res.status}, statusText: ${res.statusText}`))
})

const handleTimeout = (url, type, body = {}, json = false, times = 10000) => Promise.race([
	new Promise((rsl, rej) => {
		setTimeout(_ => {
			rsl({status: 500, statusText: 'Timeout'})
		}, times)
	}),
	fetch(handleRequest(url, type, body, json))
])

const handleParams = (params, s = '') => {
	let str = ''
	for(let i in params){
		str += `${i}=${params[i]}&`
	}
	if (str.length) {
		str = `${s}${str.substring(0, str.length - 1)}`
	}
	return str
}
//用户认证
const fetchAuth = async params => {
	const path = params.platform === 'feishu' ? 'feishu' : 'wechat'
	await handleTimeout(`/auth/${path}${handleParams(params, '?')}`, 'GET')
		.then(res => new Promise((rsl, rej) => {
			rsl(res.json())
		})).then(res => {
			if (res.code === 200) {
				isAuthing = false
				localStorage.setItem('token', res.data.token)
				localStorage.setItem('username', res.data.userName)
				localStorage.setItem('userid', res.data.userId)
				localStorage.setItem('memberid', res.data.memberId)
			}else if(res.code === 508){
				isAuthing = false
				console.log('不合法的oauth_code');
			}else{
				const memberId = res.message
				hashHistory.push({pathname: 'login', query: {memberId}})
			}
		})
}

export default {
	auth_url,
	fetchAuth,
	fetchGet (url, params = {}, times = 100000) {
		return handleTimeout(`${url}${handleParams(params, '?')}`, 'GET', null, null, times)
		.then(handleResponse)
	},
	fetchPost (url, params = {}, json = false, times = 100000) {
		return handleTimeout(url, 'POST', json ? params : handleParams(params), json, times)
		.then(handleResponse)
	},
	upload (url, params = {}) {
		return handleTimeout(url, 'UPLOAD', params, false, 900000)
		.then(handleResponse)
	},
	fetchBlob (url, params = {}) {
		return handleTimeout(`${url}${handleParams(params, '?')}`, 'GET', null, null,900000).then(function(response) {
			// console.log(response)
			if(response.status === 500 || response.code === 901){
				Toast.fail('没有找到对应的资料')
			}else{
		  		return response.blob();
			}
		})
	}
}


// WEBPACK FOOTER //
// ./src/api/index.js